import { Link } from "react-router-dom";
import Card from "../../ui/Card"

const contactCards = [
  { title: 'Get in Touch', bgColor: 'mb-6', icon: null,href:"https://aw7ew9czb25.typeform.com/to/QJEIacR1  " },
  { title: 'Discord', bgColor: '', icon: null ,href:"https://discord.gg/4htrbfJPnj"},
];

export const LetsConnect = () => {


  return (
    <div  className="mt-40  p-4">
      
           <div className="text-center">
        <h2 className="text-white">Let’s Connect</h2>
        <p className="my-5 mx-auto ">
        Looking for help? We are just a message away.       </p>
      </div>
      <div className="md:grid md:grid-cols-2 mt-10 md:mt-20 items-center sm:w-[90%] mx-auto md:w-[80%] place-items-center md:gap-4">
      {contactCards.map((card, index) => (
        <Link key={card.title} className="w-full"  target="_blank" to={card.href}>
        <Card
            key={index}
            className={`w-full hover:bg-[#2a2a2c] transition-all cursor-pointer duration-100 ${card.bgColor} md:mb-0 flex justify-center items-center h-[120px]`}
          >
           
            <div className="text-white font-medium text-2xl">{card.title}</div>
          </Card>
        </Link>
      ))}
    </div>
    </div>
  )
}




